// スマホだと2回タップしないとリンク先に飛ばない問題の対策
window.ontouchstart = function() {};
window.addEventListener('touchstart', function() {}, true);
window.addEventListener('touchstart', function() {}, false);

// 年数（コピーライト）
$(function(){
  var year = new Date().getFullYear();
  $("#year").html(year);
});

// ハンバーガーメニュー
$(function() {
  $('.header-nav-toggle-btn').on('click', function() {
    $(this).toggleClass('active');
    $('.header-content').toggleClass('show');
  });
});

// リモートボタン
$(function() {
  $('.header-remote-btn').hover(function () {
    $(this).toggleClass('show');
  });
});

// スライダー
$(function() {
  $('.kv-slider').slick({
    fade: true,
    autoplay: true,
    autoplaySpeed: 2500,
    speed: 1000,
    arrows: false,
    dots: true,
  });
});

// ページトップ
$(function() {

  var pagetop = $('.page-top');

  $(window).on('scroll', function() {
    if ($(this).scrollTop() > 1000) {
      pagetop.addClass('active');
    } else {
      pagetop.removeClass('active');
    }
  });

  pagetop.on('click', function() {
    $('html, body').animate (
      { scrollTop : 0 },
      400,
      'swing',
    );
    return false;
  });

});
